// frontend/src/contexts/FileContext.js
import React, { createContext, useContext, useState } from 'react';

const FileContext = createContext({});

export const useFiles = () => {
  const context = useContext(FileContext);
  if (!context) {
    throw new Error('useFiles must be used within FileProvider');
  }
  return context;
};

export const FileProvider = ({ children }) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadQueue, setUploadQueue] = useState([]);
  const [currentPath, setCurrentPath] = useState('/');

  const value = {
    selectedFiles,
    setSelectedFiles,
    uploadQueue,
    setUploadQueue,
    currentPath,
    setCurrentPath,
  };

  return <FileContext.Provider value={value}>{children}</FileContext.Provider>;
};